// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.filters__select .sk-select {\n  background-color: #fff;\n}\n.filters__select--multiple .sk-select__list {\n  width: calc(100% + 85px);\n}\n.filters__input .sk-input__input-wrapper {\n  background-color: #fff;\n}\n.filters__input--right-icon .sk-input__field-left-icon {\n  right: 0;\n  left: auto;\n  width: 23px;\n}\n.filters__input--right-icon .sk-input__input {\n  padding-right: 23px;\n  padding-left: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
